export const mailBodyView = [
  { label: 'resources.letter.html', value: 'HtmlBody' },
  { label: 'resources.letter.text', value: 'TextBody' },
  { label: 'resources.letter.json', value: 'RawBody' },
  { label: 'resources.letter.headers', value: 'Headers' },
];
